import { SupportAPI } from '../../utils/API/SupportAPI';
import { takeLatest, put, call, select } from 'redux-saga/effects';
import { GET_SUPPORT_TICKETS } from "../constants/support.constants";
import { supportTicketsChanged, setLoading, setError, getSupportTickets } from "../actions/support.actions";
import SupportTicket from "../../utils/models/SupportTicket";
import { APP_MOUNTED } from '../constants/app.constants';
import {selectCurrentUser} from "../selectors/app.selectors";

const api = new SupportAPI();

function* getSupportTicketsSaga() {
    try {
        const user = yield select(selectCurrentUser);
        if(!user) return;
        if(!user.isAdmin && !user.isPortalUser) return;
        
        yield put(setLoading(true));
        const tickets = yield call([api, api.getSupportTickets]);
        yield put(supportTicketsChanged(tickets.map(t => new SupportTicket(t))));
        yield put(setLoading(false));
    } catch (error) {
        yield put(setError(error.message || 'Failed to load support tickets'));
        yield put(setLoading(false));
    }
}

function* loadSupportTicketsOnMountSaga() {
    yield put(getSupportTickets());
}

export const supportSagas = [
    takeLatest(GET_SUPPORT_TICKETS, getSupportTicketsSaga),
    takeLatest(APP_MOUNTED, loadSupportTicketsOnMountSaga)
];
